module.exports = require("core-js/modules/esnext.set.join.js");